module.exports = __webpack_public_path__ + "static/determined-expanded-5-a5388c9e801a381df7f057865a04b060.png";